// Central content constants sourced from the original DigiTrans website.

export const COMPANY = {
  name: "DigiTrans",
  legalName: "DigiTrans Technology FZE",
  tagline: "Digital, Technology & Data",
  city: "Global · Dubai · Riyadh · New York · Chennai",
  phone: "+971 528 352 458",
  phoneHref: "tel:00971528352458",
  email: "Karthikk@Digitrans.partners",
  linkedin: "https://www.linkedin.com/company/digitranspartners/",
  copyrightYear: "2022",
};

export const OFFICES = [
  {
    key: "dubai",
    city: "Dubai",
    country: "United Arab Emirates",
    label: "Global HQ",
    color: "#1E5AF6",
  },
  {
    key: "riyadh",
    city: "Riyadh",
    country: "Saudi Arabia",
    label: "KSA",
    color: "#16A374",
  },
  {
    key: "nyc",
    city: "New York",
    country: "United States",
    label: "Americas",
    color: "#0B1220",
  },
  {
    key: "chennai",
    city: "Chennai",
    country: "India",
    label: "Delivery centre",
    color: "#1E5AF6",
  },
];

export const NAV_LINKS = [
  { label: "About", to: "/about", id: "about" },
  { label: "Capabilities", to: "/capabilities", id: "capabilities" },
  { label: "Oracle", to: "/oracle", id: "oracle" },
  { label: "Contact", to: "/contact", id: "contact" },
];

export const ABOUT_SECTIONS = [
  {
    key: "experience",
    label: "01 / Experience",
    title: "Our Experience",
    body: [
      "Our Digital Advisory team and industry experts collaborate with leading organizations to design and deliver transformative solutions across digital innovation, software modernization, agile transformation, and technology function evolution.",
      "We establish comprehensive partnerships that enable the rapid launch of ready-to-run solutions from day one, ensuring measurable impact and sustained value.",
      "We are a diverse team of technologists, accountants, programmers, engineers, and human-centered designers — united by a shared purpose to address the world's most critical challenges and unlock new opportunities.",
      "At DigiTrans, we invest in innovation, empower collaboration, and combine focused breadth and depth of expertise to amplify our collective impact.",
    ],
  },
  {
    key: "approach",
    label: "02 / Approach",
    title: "Our Approach",
    body: [
      "Building trust in society and solving meaningful challenges.",
      "In today's dynamic and uncertain business environment, organizations must take ownership of their digital future.",
      "At DigiTrans, our unique collaborative engagement model focuses on developing and scaling capabilities in both people and technology — simultaneously.",
      "We empower companies to design, build, and innovate through hands-on experience, deliver end-to-end digital transformation programs, and attract and retain top talent to sustain growth and resilience.",
    ],
  },
  {
    key: "why",
    label: "03 / Why us",
    title: "Why DigiTrans",
    body: [
      "DigiTrans brings together technology builders, designers, and entrepreneurs alongside leading global talent in AI, deep tech, digital growth, and sustainability. We form strategic partnerships that enable the rapid launch of ready-to-run solutions from day one.",
      "Our engagements are crafted to deliver immediate business value while simultaneously building the capabilities, processes, and mindsets required to sustain long-term digital transformation.",
      "With extensive expertise in enterprise applications, we specialize in program management, implementation, integration, support, and custom development.",
      "By combining advanced technological knowledge with entrepreneurial drive, DigiTrans helps organizations launch their next big initiatives and scale innovation across the enterprise.",
    ],
  },
];

export const INDUSTRIES = [
  {
    key: "oil-gas",
    name: "Oil & Gas",
    image:
      "https://images.pexels.com/photos/15970027/pexels-photo-15970027.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    summary:
      "DigiTrans's Global Oil, Gas & Chemicals practice partners with clients to help them unlock and maximize business potential across the entire energy value chain. From supermajors and trading enterprises to independent operators, we deliver tailored services, industry insights, and innovative solutions that align with each organization's unique objectives and people.",
  },
  {
    key: "telecom",
    name: "Telecommunications & Media",
    image:
      "https://images.unsplash.com/photo-1643155193188-38eb08e2b54f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHx0ZWxlY29tbXVuaWNhdGlvbnMlMjB0b3dlcnxlbnwwfHx8fDE3ODI5MTg4ODJ8MA&ixlib=rb-4.1.0&q=85",
    summary:
      "We help technology, media, and telecommunications leaders accelerate sustainable and inclusive growth — to build internal capabilities, integrate digital and analytics tools into their organizations, and transform the ways in which they work to improve their business in substantial, sustainable ways.",
  },
  {
    key: "transport",
    name: "Transport & Logistics",
    image:
      "https://images.unsplash.com/photo-1606185540834-d6e7483ee1a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxzaGlwcGluZyUyMHBvcnQlMjBsb2dpc3RpY3N8ZW58MHx8fHwxNzgyOTE4ODgyfDA&ixlib=rb-4.1.0&q=85",
    summary:
      "A proven track record and deep expertise across Road & Traffic, Rail & Metro, Aviation & Airports, Maritime & Ports, and Postal & Logistics. Our offerings help meet needs across Strategy Development, Operating Model Transformation, Digitization, Operational Efficiency, and Privatization.",
  },
  {
    key: "retail",
    name: "Retail & Consumer",
    image:
      "https://images.unsplash.com/photo-1511317559916-56d5ddb62563?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjByZXRhaWwlMjBzdG9yZSUyMGludGVyaW9yfGVufDB8fHx8MTc4MjkxODg4Mnww&ixlib=rb-4.1.0&q=85",
    summary:
      "Today's retail sector faces multiple new challenges — increasing competition and changing consumer behavior among them. New technological developments are opening up future-oriented sales channels and enabling far-reaching process optimization across the entire organization. We advise proactively so clients can anticipate future developments, achieve synergies, and identify optimization potentials.",
  },
  {
    key: "financial",
    name: "Financial Services",
    image:
      "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxmaW5hbmNpYWwlMjBzdG9jayUyMG1hcmtldCUyMGNoYXJ0c3xlbnwwfHx8fDE3ODI5MTg4ODJ8MA&ixlib=rb-4.1.0&q=85",
    summary:
      "We help financial services firms navigate operations and IT challenges from the back office to the front line. Our clients include leading banks, insurers, asset managers, and payments players in all major markets. Our global network augments client work with a robust proprietary knowledge base of research, benchmarks, and tools.",
  },
  {
    key: "construction",
    name: "Construction & Building Materials",
    image:
      "https://images.unsplash.com/photo-1599707254554-027aeb4deacd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4MjkxODg4Mnww&ixlib=rb-4.1.0&q=85",
    summary:
      "Navigate technological disruption and build a successful, sustainable, digitally-driven business enabled by innovation — process, tools, organization, and mindsets — business information modeling, process digitization, agile engineering, and advanced analytics.",
  },
];

export const CAPABILITIES = [
  {
    key: "ai",
    number: "C.01",
    title: "Artificial Intelligence across enterprise applications",
    summary:
      "Embed AI, ML and Generative AI into ERP, CX, HCM, supply chain and finance systems — from copilots and intelligent automation to forecasting and anomaly detection.",
    detail:
      "We help enterprises move from AI experiments to production impact. Our teams design and implement AI-driven copilots inside Oracle Fusion, custom LLM assistants for finance and procurement, RAG-based knowledge systems, predictive analytics, computer vision on operational data, and MLOps foundations that make AI safe, governed and scalable across the enterprise.",
  },
  {
    key: "digital",
    number: "C.02",
    title: "Digital transformation services",
    summary:
      "We help companies thrive in the transformative age by refreshing themselves constantly, experimenting with new ideas, and scaling successes.",
    detail:
      "Technology is the business agenda. Customers' expectations for access to technology products and services are rapidly increasing — user-centric, mobile, agile, and data-driven capabilities are table stakes for every organization. Companies must consider foundational technology transformation to adapt and compete.",
  },
  {
    key: "fitment",
    number: "C.03",
    title: "Product fitment advisory",
    summary:
      "We help determine the right cloud strategy, solutions, operating model, roadmap, and ecosystem partnerships.",
    detail:
      "Combining deep industry expertise with technology insights, we advise on the right product fitment for your line of business, integration options, articulating precise business requirements, and evaluating vendors. Sizing of licenses in terms of volume and cost across cloud and on-premise products is a core strength.",
  },
  {
    key: "ams",
    number: "C.04",
    title: "Application managed services",
    summary:
      "From development of new applications through modernization, management, and maintenance — we cover the full application lifecycle.",
    detail:
      "Our approach to application management embraces technology innovation as a business driver, using New IT to transform the application landscape end-to-end.",
  },
  {
    key: "backoffice",
    number: "C.05",
    title: "Back office services",
    summary:
      "Outsource back office operations so you can focus complete attention on the components that grow your business.",
    detail:
      "When back-office operations are handled by us, our clients concentrate on strategic priorities. We deliver reliable, cost-efficient services with clear SLAs so nothing falls through the cracks.",
  },
  {
    key: "supply",
    number: "C.06",
    title: "Supply chain & operations",
    summary:
      "Re-imagine, build, and operate supply chain networks that orchestrate change, simplify life, and positively impact business, society, and the planet.",
    detail:
      "We help companies manage the complexity of transforming supply chains into future-ready networks that balance the evolving expectations of customers, employees, and investors, fuel profitable growth, and do business the right way.",
  },
  {
    key: "finance",
    number: "C.07",
    title: "Finance consulting",
    summary:
      "Extensive experience across the entire finance transformation journey — delivering 360° value.",
    detail:
      "Our ability to predict outcomes with confidence empowers finance and risk executives to rapidly evaluate opportunities and drive the right changes across the enterprise — benefiting customers, employees, shareholders, communities, and the environment.",
  },
  {
    key: "design",
    number: "C.08",
    title: "Design thinking",
    summary:
      "End-to-end capabilities spanning experience strategy, design, development, and management.",
    detail:
      "Guided by our unique approach to Business Design, we deliver human-centered products and services that create measurable value.",
  },
];

export const ORACLE_MODULES = [
  {
    key: "oracle-ai",
    number: "O.01",
    title: "Oracle Artificial Intelligence",
    featured: true,
    items: [
      "Oracle AI Services (Vision, Speech, Language, Anomaly Detection)",
      "Oracle Digital Assistant & AI-driven chatbots",
      "AI-embedded Fusion Cloud analytics & narrative reporting",
      "Model deployment on OCI Data Science / GPU shapes",
      "Responsible AI governance, bias & drift monitoring",
    ],
  },
  {
    key: "oracle-genai",
    number: "O.02",
    title: "Oracle Generative AI",
    featured: true,
    items: [
      "OCI Generative AI (Cohere Command, Llama) integration",
      "GenAI Agents Service for enterprise assistants",
      "Retrieval-augmented generation (RAG) on Oracle 23ai vector search",
      "Prompt engineering, fine-tuning & guardrails",
      "GenAI embedded into Fusion Financials, HCM, SCM workflows",
    ],
  },
  {
    key: "fusion-agentic",
    number: "O.03",
    title: "Fusion Agentic Applications",
    featured: true,
    items: [
      "Oracle Fusion AI Agents for finance, procurement, HR & supply chain",
      "Custom agent studios on OCI GenAI Agents",
      "Autonomous close, invoice & touchless procurement flows",
      "Human-in-the-loop orchestration & audit trails",
      "Agent-to-agent integration across Fusion pillars",
    ],
  },
  {
    key: "ai-data-platform",
    number: "O.04",
    title: "AI Data Platform",
    featured: true,
    items: [
      "Oracle 23ai Vector Database & AI Vector Search",
      "Autonomous Database + Data Lakehouse on OCI",
      "Data pipelines with OCI Data Integration & GoldenGate",
      "Feature stores, MLOps & model registry",
      "Unified governance across structured + unstructured data",
    ],
  },
  {
    key: "fusion",
    number: "O.05",
    title: "Fusion Applications",
    items: [
      "Financials",
      "Procurement",
      "Project Portfolio Management",
      "Supply Chain Management",
      "Human Resources Management",
    ],
  },
  {
    key: "epm",
    number: "O.06",
    title: "Enterprise Performance Management",
    items: ["Planning & Budgeting", "Consolidation", "Reconciliation", "Narrative reporting"],
  },
  {
    key: "fah",
    number: "O.07",
    title: "Finance Accounting Hub",
    items: [
      "Setting source system for data import",
      "Configure accounting rules",
      "Configure journal line rules and formulas",
      "Upload of transactions & automated processing",
      "Reconciliation with source system",
      "Reporting and analysis",
    ],
  },
  {
    key: "oic",
    number: "O.08",
    title: "Oracle Integration Cloud",
    items: [
      "Development of integrations leveraging OIC with any cloud or on-premise (net exposed) application",
      "Maintenance and upkeep of OIC suite",
    ],
  },
  {
    key: "oci",
    number: "O.09",
    title: "Oracle Cloud Infrastructure",
    items: ["Migration of applications", "Managed hosting", "Upgrades and support"],
  },
  {
    key: "ebs",
    number: "O.10",
    title: "E-Business Suite Application",
    items: [
      "Financials",
      "Supply chain",
      "Manufacturing",
      "Procurement",
      "Treasury",
      "Human resources & payroll",
      "Custom developments",
    ],
  },
  {
    key: "extensions",
    number: "O.11",
    title: "Extensions",
    items: [
      "PaaS developments for cloud",
      "On-premise extensions as Apex",
      "VBCS",
      "Custom forms along with process solutions",
    ],
  },
  {
    key: "migration",
    number: "O.12",
    title: "Data Migration",
    items: [
      "Tools to migrate E-Business Suite to Fusion Cloud",
      "Extraction scripts for master & transactional data from E-Business Suite",
      "ETL tools to clean extracted data and fix errors before upload",
      "Handling of master data duplication",
    ],
  },
];

export const PARTNER_LOGOS = [
  { name: "Expresso Telecom", src: "https://img1.wsimg.com/isteam/ip/0e67d007-e871-416b-a051-74581d150675/EXPRESSO%20TELECOM.png/:/rs=h:100,cg:true,m" },
  { name: "EHC", src: "https://img1.wsimg.com/isteam/ip/0e67d007-e871-416b-a051-74581d150675/ehc-6b6aae8.png/:/rs=h:100,cg:true,m" },
  { name: "Kenya Airways", src: "https://img1.wsimg.com/isteam/ip/0e67d007-e871-416b-a051-74581d150675/KQ-ebedde0.PNG/:/rs=h:100,cg:true,m" },
  { name: "Transworld", src: "https://img1.wsimg.com/isteam/ip/0e67d007-e871-416b-a051-74581d150675/transworld-8a468b3.png/:/rs=h:100,cg:true,m" },
  { name: "ZainTech", src: "https://img1.wsimg.com/isteam/ip/0e67d007-e871-416b-a051-74581d150675/zaintech-a2d066b.png/:/rs=h:100,cg:true,m" },
  { name: "Mazrui International", src: "https://img1.wsimg.com/isteam/ip/0e67d007-e871-416b-a051-74581d150675/mazrui%20international%20-abce321.png/:/rs=h:100,cg:true,m" },
  { name: "Oracle Partner", src: "https://img1.wsimg.com/isteam/ip/0e67d007-e871-416b-a051-74581d150675/oracle%20partner2.png/:/rs=h:100,cg:true,m" },
  { name: "TASC", src: "https://img1.wsimg.com/isteam/ip/0e67d007-e871-416b-a051-74581d150675/tasc-a86d634.JPG/:/rs=h:100,cg:true,m" },
  { name: "VIVA Telecom Kuwait", src: "https://img1.wsimg.com/isteam/ip/0e67d007-e871-416b-a051-74581d150675/viva%20telecom%20kuwait-064fad6.png/:/rs=h:100,cg:true,m" },
  { name: "DPE", src: "https://img1.wsimg.com/isteam/ip/0e67d007-e871-416b-a051-74581d150675/dpe-82da0c4.PNG/:/rs=h:100,cg:true" },
  { name: "OAB", src: "https://img1.wsimg.com/isteam/ip/0e67d007-e871-416b-a051-74581d150675/OAB1.png/:/rs=h:100,cg:true,m" },
  { name: "Zycus", src: "https://img1.wsimg.com/isteam/ip/0e67d007-e871-416b-a051-74581d150675/zycus-s2p-logo.webp/:/rs=h:100,cg:true" },
  { name: "OSC", src: "https://img1.wsimg.com/isteam/ip/0e67d007-e871-416b-a051-74581d150675/osc2.png/:/rs=h:100,cg:true,m" },
  { name: "Delot", src: "https://img1.wsimg.com/isteam/ip/0e67d007-e871-416b-a051-74581d150675/delot2.png/:/rs=h:100,cg:true,m" },
  { name: "ADA", src: "https://img1.wsimg.com/isteam/ip/0e67d007-e871-416b-a051-74581d150675/ADA2.jpg/:/rs=h:100,cg:true,m" },
  { name: "ENOC", src: "https://img1.wsimg.com/isteam/ip/0e67d007-e871-416b-a051-74581d150675/enoc2.png/:/rs=h:100,cg:true,m" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1615747476328-41153cf6da54?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxkdWJhaSUyMG1vZGVybiUyMGFyY2hpdGVjdHVyZSUyMG9mZmljZXxlbnwwfHx8fDE3ODI5MTg4NTh8MA&ixlib=rb-4.1.0&q=85",
  tech: "https://images.unsplash.com/photo-1633098096956-afdc8bcc8552?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMGRpZ2l0YWwlMjBkYXRhJTIwY2xvdWQlMjBjb21wdXRpbmd8ZW58MHx8fHwxNzgyOTE4ODU4fDA&ixlib=rb-4.1.0&q=85",
  team: "https://images.unsplash.com/photo-1551135049-8a33b5883817?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBjb3Jwb3JhdGUlMjBjb25zdWx0aW5nJTIwdGVhbXxlbnwwfHx8fDE3ODI5MTg4NTh8MA&ixlib=rb-4.1.0&q=85",
};
